var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVoiceBroadcast1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2204_86",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#474747"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2204_86)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.95 15.95L18.4 14.4C19.1333 13.7167 19.7083 12.9083 20.125 11.975C20.5417 11.0417 20.75 10.05 20.75 9C20.75 7.95 20.5417 6.96667 20.125 6.05C19.7083 5.13333 19.1333 4.33333 18.4 3.65L19.95 2.05C20.8833 2.93333 21.625 3.975 22.175 5.175C22.725 6.375 23 7.65 23 9C23 10.35 22.725 11.625 22.175 12.825C21.625 14.025 20.8833 15.0667 19.95 15.95ZM16.75 12.75L15.15 11.15C15.45 10.8667 15.6917 10.5458 15.875 10.1875C16.0583 9.82917 16.15 9.43333 16.15 9C16.15 8.56667 16.0583 8.17083 15.875 7.8125C15.6917 7.45417 15.45 7.13333 15.15 6.85L16.75 5.25C17.2833 5.73333 17.7 6.29583 18 6.9375C18.3 7.57917 18.45 8.26667 18.45 9C18.45 9.73333 18.3 10.4208 18 11.0625C17.7 11.7042 17.2833 12.2667 16.75 12.75ZM9 13C7.9 13 6.95833 12.6083 6.175 11.825C5.39167 11.0417 5 10.1 5 9C5 7.9 5.39167 6.95833 6.175 6.175C6.95833 5.39167 7.9 5 9 5C10.1 5 11.0417 5.39167 11.825 6.175C12.6083 6.95833 13 7.9 13 9C13 10.1 12.6083 11.0417 11.825 11.825C11.0417 12.6083 10.1 13 9 13ZM1 21V18.2C1 17.65 1.14167 17.1333 1.425 16.65C1.70833 16.1667 2.1 15.8 2.6 15.55C3.45 15.1167 4.40833 14.75 5.475 14.45C6.54167 14.15 7.71667 14 9 14C10.2833 14 11.4583 14.15 12.525 14.45C13.5917 14.75 14.55 15.1167 15.4 15.55C15.9 15.8 16.2917 16.1667 16.575 16.65C16.8583 17.1333 17 17.65 17 18.2V21H1Z",
    fill: "#474747"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVoiceBroadcast1);
export default __webpack_public_path__ + "static/media/VoiceBroadcast1.1b66cb32499913aac87db3e3c50812c0.svg";
export { ForwardRef as ReactComponent };